import { Component, OnInit, ElementRef, Inject, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { OwnService } from '../../services/owners/own.service';
import { VehService } from '../../services/vehicles/veh.service';

@Component({
  selector: 'app-dialog-assign',
  templateUrl: './dialog.component.assign.html',
  providers: [OwnService, VehService]
})
export class DialogAssignComponent implements OnInit {
  public searchText: string = '';
  public availableItems: Array<any> = [];
  public filteredItems: Array<any> = [];
  public selectedItems: Array<any> = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      mode: 'vehicle-to-owner' | 'owner-to-vehicle',
      id: string,
      currentAssignments: Array<any>
    },
    private dialogRef: MatDialogRef<DialogAssignComponent>,
    private ownersService: OwnService,
    private vehiclesService: VehService
  ) {}

  ngOnInit() {
    // Copia les assignacions actuals com a seleccionades
    this.selectedItems = [...this.data.currentAssignments];

    // Carrega la llista de l'altre costat
    if (this.data.mode === 'vehicle-to-owner') {
      this.ownersService.getAutocomplete('id').subscribe(data => {
        this.availableItems = data;
        this.filteredItems = data;
      });
    } else {
      this.vehiclesService.getAutocomplete('plate').subscribe(data => {
        this.availableItems = data;
        this.filteredItems = data;
      });
    }
  }

  public filter() {
    const text = this.searchText.toLowerCase();

    this.filteredItems = this.availableItems.filter(item =>
      Object.values(item).some(v => String(v).toLowerCase().includes(text))
    );
  }

  public isSelected(item: any): boolean {
    const key = this.data.mode === 'vehicle-to-owner' ? 'owner_id' : 'plate';
    return this.selectedItems.some(s => s[key] === item['value'] || s[key] === item['text']);
  }

  public toggleItem(item: any) {
    const key = this.data.mode === 'vehicle-to-owner' ? 'owner_id' : 'plate';
    console.log(item);
    console.log(this.selectedItems);
    if (this.isSelected(item)) {
      this.selectedItems = this.selectedItems.filter(s => s[key] !== item['value']);
    } else {
      this.selectedItems.push( { 'id': item['value'], 'name': item['text'] }  );
    }
  }

  public confirm() {
    console.log(this.selectedItems);
    this.dialogRef.close(this.selectedItems);
  }

  public cancel() {
    this.dialogRef.close(null);
  }
}